var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 77,
    viewBox: "0 0 107 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.3 61.3998V14.7998H0.700012V61.3998C0.700012 62.9998 2.00001 64.2998 3.60001 64.2998H84.4C86 64.2998 87.3 62.9998 87.3 61.3998Z",
    fill: "#82AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3 2.9C87.3 1.3 86 0 84.4 0H3.50001C1.90001 0 0.600006 1.3 0.600006 2.9V12.3H87.3V2.9Z",
    fill: "#82AA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60002 7.6C8.59413 7.6 9.40002 6.79411 9.40002 5.8C9.40002 4.80589 8.59413 4 7.60002 4C6.60591 4 5.80002 4.80589 5.80002 5.8C5.80002 6.79411 6.60591 7.6 7.60002 7.6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 7.6C14.1941 7.6 15 6.79411 15 5.8C15 4.80589 14.1941 4 13.2 4C12.2059 4 11.4 4.80589 11.4 5.8C11.4 6.79411 12.2059 7.6 13.2 7.6Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9 7.6C19.8941 7.6 20.7 6.79411 20.7 5.8C20.7 4.80589 19.8941 4 18.9 4C17.9059 4 17.1 4.80589 17.1 5.8C17.1 6.79411 17.9059 7.6 18.9 7.6Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76 22.2998H11.9V32.7998H76V22.2998Z",
    stroke: "white",
    strokeWidth: 1.8972,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1 39.1001H11.2V57.5001H28.1V39.1001Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 39.1001H35.6V57.5001H52.5V39.1001Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9 39.1001H60V57.5001H76.9V39.1001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 75.5C94 75.5 105 64.5 105 51C105 37.5 94 26.5 80.5 26.5C67 26.5 56 37.5 56 51C56 64.5 67 75.5 80.5 75.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1 55C67.4 56 67.8 56.9 68.2 57.8L65.6 61.7L69.8 65.9L73.7 63.3C74.6 63.8 75.5 64.2 76.5 64.4L77.4 69H83.4L84.3 64.4C85.3 64.1 86.2 63.7 87.1 63.3L91 65.9L95.2 61.7L92.6 57.8C93.1 56.9 93.5 56 93.7 55L98.3 54.1V48.1L94 47.1C93.7 46.1 93.3 45.2 92.9 44.3L95.5 40.4L91.3 36.2L87.4 38.8C86.5 38.3 85.6 37.9 84.6 37.7L83.5 33H77.5L76.6 37.6C75.6 37.9 74.7 38.3 73.8 38.7L69.9 36.1L65.7 40.3L68.3 44.2C67.8 45.1 67.4 46 67.2 47L62.5 48V54L67.1 55ZM87.4 51C87.4 54.8 84.3 57.8 80.6 57.8C76.9 57.8 73.8 54.7 73.8 51C73.8 47.2 76.9 44.2 80.6 44.2C84.3 44.2 87.4 47.2 87.4 51Z",
    fill: "#82AA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSettings);
export default __webpack_public_path__ + "static/media/global_settings.7b52c708b78951b337398afdfcaf8d62.svg";
export { ForwardRef as ReactComponent };